import React from 'react';

type Props = {  onAddInject: () => void;
  onAddFunction: () => void;
  onAddHttpResponse: () => void;
};

export const FlowComposerPalette: React.FC<Props> = ({
  onAddInject,
  onAddFunction,
  onAddHttpResponse,
}) => (
  <aside className="w-52 shrink-0 border-r border-white/10 bg-[#12121a] p-4">
    <p className="text-[10px] font-bold uppercase tracking-widest text-slate-500 mb-3">Paleta</p>
    <ul className="space-y-2">
      <PaletteItem label="Gatilho" hint="inject" color="bg-emerald-500" onClick={onAddInject} />
      <PaletteItem label="Função" hint="function" color="bg-amber-500" onClick={onAddFunction} />
      <PaletteItem
        label="Resposta HTTP"
        hint="http response"
        color="bg-sky-500"
        onClick={onAddHttpResponse}
      />
    </ul>
    <p className="mt-6 text-xs text-slate-500 leading-relaxed">
      Arraste no canvas ou clique para adicionar. Conecte as saídas arrastando entre os nós.
    </p>
  </aside>
);

function PaletteItem({
  label,
  hint,
  color,
  onClick,
}: {
  label: string;
  hint: string;
  color: string;
  onClick: () => void;
}) {
  return (
    <li>
      <button
        type="button"
        onClick={onClick}
        className="flex w-full items-center gap-3 rounded-lg border border-white/10 bg-white/5 px-3 py-2.5 text-left text-sm text-slate-200 transition hover:border-red-400/50 hover:bg-red-500/10"
      >
        <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${color}`} />
        <span>
          <span className="block font-medium">{label}</span>
          <span className="block text-[10px] text-slate-500">{hint}</span>
        </span>
      </button>
    </li>
  );
}
